import { render } from "./AllDocuments.vue?vue&type=template&id=684f3c38"
import script from "./AllDocuments.vue?vue&type=script&lang=js"
export * from "./AllDocuments.vue?vue&type=script&lang=js"

import "./AllDocuments.vue?vue&type=style&index=0&id=684f3c38&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__